import { Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import {
    LOGO_URL,
    CONTACT_EMAIL,
    CONTACT_PHONE,
    CONTACT_PHONE_HREF,
} from "@/lib/brand";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="relative luxe-radial-faint border-t border-white/[0.05] pt-20 pb-10"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
                <div className="grid md:grid-cols-12 gap-12">
                    <div className="md:col-span-6">
                        <div className="flex items-center gap-4">
                            <img
                                src={LOGO_URL}
                                alt="RecoveryDesk"
                                className="h-14 w-14 object-cover rounded-sm ring-1 ring-[#D4AF37]/30"
                            />
                            <div>
                                <div className="font-display text-2xl tracking-wide text-silver-gold">
                                    RecoveryDesk
                                </div>
                                <div className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mt-1">
                                    Your Business Beautifully Built
                                </div>
                            </div>
                        </div>
                        <p className="mt-8 max-w-md text-sm text-[#888] font-light leading-relaxed">
                            Custom web design and development for small and
                            medium-sized businesses — beautifully built,
                            professionally launched, and continuously supported.
                        </p>
                    </div>

                    <div className="md:col-span-6 md:flex md:justify-end">
                        <div className="space-y-5">
                            <div className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">
                                Contact
                            </div>
                            <a
                                data-testid="footer-email"
                                href={`mailto:${CONTACT_EMAIL}`}
                                className="flex items-center gap-3 text-sm text-white hover:text-[#D4AF37] transition-colors"
                            >
                                <Mail className="w-4 h-4 text-[#D4AF37]" strokeWidth={1.5} />
                                {CONTACT_EMAIL}
                            </a>
                            <a
                                data-testid="footer-phone"
                                href={CONTACT_PHONE_HREF}
                                className="flex items-center gap-3 text-sm text-white hover:text-[#D4AF37] transition-colors"
                            >
                                <Phone className="w-4 h-4 text-[#D4AF37]" strokeWidth={1.5} />
                                {CONTACT_PHONE}
                            </a>
                        </div>
                    </div>
                </div>

                <div className="mt-16 gold-rule" />

                <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                    <p className="text-xs text-[#666] font-light tracking-wide">
                        © {year} RecoveryDesk. All rights reserved.
                    </p>
                    <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-[10px] uppercase tracking-[0.25em]">
                        <Link
                            data-testid="footer-privacy"
                            to="/privacy"
                            className="text-[#888] hover:text-[#D4AF37] transition-colors"
                        >
                            Privacy Policy
                        </Link>
                        <Link
                            data-testid="footer-terms"
                            to="/terms"
                            className="text-[#888] hover:text-[#D4AF37] transition-colors"
                        >
                            Terms &amp; Conditions
                        </Link>
                        <span className="text-[#666] tracking-[0.3em]">
                            Web Design &amp; Development
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
